import { useRef } from 'react';
import { Dialog, DialogTitle, Typography, Box, IconButton, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import CloseIcon from '@mui/icons-material/Close';
import { HelpButton } from '../Help';
import { useGetNotification } from '../../../logic/useApiQuery';
import { UseMutateFunction } from '@tanstack/react-query';

interface FormSubmitErrorDialogProps {
    open: boolean;
    setFormSubmitErrorOpen: (open: boolean) => void;
    mutateFormSubmit: UseMutateFunction<unknown, unknown, { formData: any; notificationId?: string }, unknown>;
    formData: any;
}

export function FormSubmitErrorDialog({ open, setFormSubmitErrorOpen, mutateFormSubmit, formData }: FormSubmitErrorDialogProps) {

  const { data: notification } = useGetNotification()
  const isResubmittingRef = useRef(false)

  const handleResubmit = () => {
    if (isResubmittingRef.current) return
    isResubmittingRef.current = true
    mutateFormSubmit(
      { formData, notificationId: notification?.NotificationId },
      { onSettled: () => { isResubmittingRef.current = false } }
    )
    setFormSubmitErrorOpen(false)
  }

  return <Dialog
    key="formSubmitError" open={open}
  >
    <DialogTitle
      id="alert-dialog-title"
      sx={{
        display: "flex",
        justifyContent: "space-between",
        ml: -1,
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "left",
          alignItems: "center",
          mr: 4,
        }}
      >
        <ErrorOutlineIcon fontSize="large" color="error" sx={{ mr: 1 }} />
        <Typography
          sx={{
            fontWeight: "500",
            lineHeight: "18px",
          }}
        >
                    Sorry, something went wrong
        </Typography>
      </Box>
      <IconButton
        aria-label="close"
        onClick={() => {
          setFormSubmitErrorOpen(false);
        }}
        sx={{
          position: "absolute",
          right: 8,
          top: 10,
        }}
      >
        <CloseIcon />
      </IconButton>
    </DialogTitle>
    <DialogContent>
      <DialogContentText id="alert-dialog-description">
                There was an error submitting your form.
      </DialogContentText>
    </DialogContent>

    <DialogActions>
      <HelpButton />
      <Button
        onClick={handleResubmit}
      >
                Resubmit your form
      </Button>
    </DialogActions>
  </Dialog>
}
